/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React,{ useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql} from "gatsby"

import Header from "../components/header/header";
import "normalize.css";
import "./layout.scss";

import { Helmet } from 'react-helmet';
import MenuScroll from '../components/menuScroll/menuScroll';

import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from "gsap";

gsap.registerPlugin(ScrollTrigger);


const Layout = ({ children }) => {

  const innerCursorRef = useRef(null);
  const outerCursorRef = useRef(null);

  useEffect(() => {

    document.addEventListener('mousemove',(e)=>{
      innerCursorRef.current.style.left=`${e.clientX}px`
      innerCursorRef.current.style.top=`${e.clientY}px`
      outerCursorRef.current.style.left=`${e.clientX}px`
      outerCursorRef.current.style.top=`${e.clientY}px`
    })

    return () => {}

  }, []);

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Helmet>
      </Helmet>

      <Header siteTitle={ `L` || `L - ${data.site.siteMetadata?.title }`} />

      <main>
        <MenuScroll/>
        {children}
        <div ref={innerCursorRef} className="inner_cursor"></div>
        <div ref={outerCursorRef} className="outer_cursor"></div>
      </main>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
